import { render } from "./header.vue?vue&type=template&id=448dfe11&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"

import "./header.vue?vue&type=style&index=0&id=448dfe11&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-448dfe11"

export default script